import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '../stores/store';
import {getCoins, getProfile, ProfileState} from '../features/profile/profileSlice';

import {CircularProgress, Grid, List, ListItem, ListItemText, Typography,} from '@mui/material';
import {getPersonalData} from "../features/profile/personalDataProfileSlice";
import useProfileStyles from "../styles/profile";
import HelloComponent from "../components/profile/HelloComponent";
import TeaserFrame2 from "../components/TeaserFrame2";
import theme from "../styles/themes/default";
import GameSpinBottleHistory from "../components/kozelMeet/GameSpinBottleHistory";
import GameChallengeUntoldHistory from "../components/profile/GameChallengeUntoldHistory";


const Profile: React.FC = () => {
    const dispatch = useAppDispatch();
    const profileStyles = useProfileStyles();
    const profile: ProfileState = useAppSelector((state) => state.profile);

    useEffect(() => {
        dispatch(getProfile());
        dispatch(getPersonalData());
        dispatch(getCoins());
    }, [dispatch]);

    if (profile.loading) {
        return <CircularProgress/>;
    }

    return (
        <Grid container className={profileStyles.container} flexDirection={'column'}>
            <Grid item xs={12}>
                <HelloComponent/>
            </Grid>
            <Grid item xs={12}>
                <GameSpinBottleHistory/>
            </Grid>
            <Grid item xs={12}>
                <GameChallengeUntoldHistory/>
            </Grid>
            <Grid item xs={12} className={profileStyles.backgroundCreamLate}>
                <TeaserFrame2
                    title={<Typography className={profileStyles.titleHowGetCoins}>How to win points?</Typography>}
                    titleMarginTop={'min(-5vh,-5vw)'}
                    backgroundBoxTitle={theme.colors.latte_cream}
                    colorBorderDotted={theme.colors.dark_chocolate}
                >
                    <List className={profileStyles.listHowGetCoins}>
                        <ListItem><ListItemText>you get being here and having an account on kozel.ro</ListItemText></ListItem>
                        <ListItem><ListItemText>your group gets 50 points for each member addition</ListItemText></ListItem>
                        <ListItem><ListItemText>you get 50 points for filling in your profile data</ListItemText></ListItem>
                        <ListItem><ListItemText>you get 50 loyalty points each year</ListItemText></ListItem>
                        <ListItem><ListItemText>In addition, stay tuned for the special campaigns, when you will have a chance to win extra points.</ListItemText></ListItem>
                    </List>
                </TeaserFrame2>
            </Grid>
        </Grid>
    );
};

export default Profile;
